export default __webpack_public_path__ + "static/media/next.b4e08bbf.svg";